import { connect } from 'react-redux';
import { setPage } from '../actions/page';
import { fetchPosts } from '../actions/posts';
import { pushStateChange } from '../history';
import ResourceList from '../components/resource-list';

const mapStateToProps = state => {
	return {
		filter: state.filter,
		page: state.page.page,
		totalPages: state.page.total,
		isLoading: state.posts.isLoading,
		content: state.posts.content ? state.posts.content : state.posts.staticHtml
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onClickPage: n => {
			let pageNumber = n.selected + 1;
			dispatch(setPage(pageNumber));
			dispatch(fetchPosts());
			dispatch(function(dispatch, getState) {
				return pushStateChange(dispatch, getState);
			});
		}
	};
};

const ResourceListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ResourceList);

export default ResourceListContainer;
